import { useLocation } from 'react-router-dom';
import { PageLoader } from '../components/Feedback';

/**
 * Prerendered pages (SEO, 2026-10-27): the server sends website pages as finished HTML. Until React has loaded the
 * page's code and data, loaders show that same HTML instead of a spinner, so the page does not flash empty.
 */
let captured: { path: string; html: string } | null = null;

/** Call once before React mounts: keeps the server's HTML of the first page. */
export function capturePrerendered(root: HTMLElement) {
  if (root.firstElementChild && root.dataset.prerendered === 'true') captured = { path: window.location.pathname, html: root.innerHTML };
}

export function wasPrerendered(pathname: string): boolean {
  return captured?.path === pathname;
}

/** PageLoader, or the prerendered HTML of the first page while it is still loading. */
export function BootFallback() {
  const { pathname } = useLocation();
  if (captured && captured.path === pathname) return <div style={{ display: 'contents' }} dangerouslySetInnerHTML={{ __html: captured.html }} />;
  return <PageLoader />;
}
